<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h3>{{formTitle}}</h3>
      </v-flex>
      <v-flex xs12>
        <v-tabs>
          <v-tab href="#tab-1">
            Основные данные
          </v-tab>
          <v-tab-item
                  :value="'tab-1'">
            <v-card>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4 lg2>
                      <v-text-field
                              v-model.trim="payer.surname"
                              label="Фамилия"
                              :error-messages="requiredErrors('surname')"
                              @blur="$v.payer.surname.$touch()"

                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg2>
                      <v-text-field
                              v-model.trim="payer.first_name"
                              label="Имя"
                              :error-messages="requiredErrors('first_name')"
                              @blur="$v.payer.first_name.$touch()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg2>
                      <v-text-field
                              v-model.trim="payer.patronymic"
                              label="Отчество"
                              :error-messages="requiredErrors('patronymic')"
                              @blur="$v.payer.patronymic.$touch()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg2>
                      <v-text-field
                              v-model.trim="payer.date_of_birth"
                              label="Дата рождения"
                              type="date"
                              :error-messages="requiredErrors('date_of_birth')"
                              @blur="$v.payer.date_of_birth.$touch()"
                      ></v-text-field>
                    </v-flex>
                      <v-flex xs12>
                          <v-text-field
                                  v-model.trim="payer.address"
                                  label="Адрес"
                                  :error-messages="requiredErrors('address')"
                                  @blur="$v.payer.address.$touch()"
                          ></v-text-field>
                      </v-flex>
                      <v-layout  wrap  class="bloc">
                          <v-flex xs12>
                              <v-autocomplete
                                      v-bind:items="typeDocument"
                                      item-text="name"
                                      item-value="id"
                                      v-model="payer.type_document"
                                      label="Вид документа"
                                      :loading="listLoading.includes('fetchTypeDocument')"
                                      v-on:change="setNullDocument"

                              >
                              </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6
                                  v-if="getTypeDocument(payer.type_document).name_field_series_document"
                          >
                              <v-text-field
                                      v-model.trim="payer.series_document"
                                      :label=getTypeDocument(payer.type_document).name_field_series_document
                                      :mask=getTypeDocument(payer.type_document).mask_series_document
                                      counter
                                      :error-messages="requiredErrors('series_document')"
                                      @blur="$v.payer.series_document.$touch()"
                              ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6
                                  v-if="getTypeDocument(payer.type_document).name_field_number_document"
                          >
                              <v-text-field
                                      v-model.trim="payer.number_document"
                                      :label=getTypeDocument(payer.type_document).name_field_number_document
                                      :mask=getTypeDocument(payer.type_document).mask_number_document
                                      counter
                                      :error-messages="requiredErrors('number_document')"
                                      @blur="$v.payer.number_document.$touch()"
                              ></v-text-field>
                          </v-flex>
                      </v-layout>

                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab href="#tab-2">
            Системные данные
          </v-tab>
          <v-tab-item
                  :value="'tab-2'">
              <system-form :system-info=payer></system-form>
          </v-tab-item>
        </v-tabs>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                      v-if="!payer.result"
                      @click.native="save">Сохранить</v-btn>
              <v-btn
                      v-if="!payer.result && this.$route.params.payer_id !== 'new'"
                      @click.native="del">Удалить</v-btn>
              <v-btn @click.native="cancel">Список</v-btn>
          </v-card-actions>
      </v-flex>
        <v-flex xs12>
            <router-view style="padding: 0"></router-view>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import SystemForm from '../../common/systemForm'

function validatorRus (word) {
  if (word === '') {
    return true
  }
  return /^[А-Яа-яЁё '.-]+$/.test(word)
}
function validatorRusDigit (word) {
  if (word === '') {
    return true
  }
  return /^[А-Яа-яЁё0-9 №()'.,-/]+$/.test(word)
}
function validatorSeries (word) {
  if (this.payer.type_document === 1) {
    return /^[0-9]{4}$/.test(word)
  }
  if (this.payer.type_document === 2) {
    return /^[I,V,X,L,C,D,M]{1,4}[А-Я]{2}$/.test(word)
  }
  if (this.payer.type_document === 8) {
    return /^[0-9a-zA-Z]+$/.test(word)
  }
  return /^[0-9a-zA-Zа-яА-Я]*$/.test(word)
}
function validatorNumber (word) {
  if ([1, 2].includes(this.payer.type_document)) {
    return /^[0-9]{6}$/.test(word)
  }
  if ([8].includes(this.payer.type_document)) {
    return /^[0-9]+$/.test(word)
  }
  if (this.payer.type_document === 14) {
    return /^[0-9]{11}$/.test(word)
  }
  return /^[0-9a-zA-Zа-яА-Я]*$/.test(word)
}

export default {
  components: { SystemForm },
  data () {
    return {

    }
  },
  mixins: [validationMixin],
  validations: {
    payer: {
      surname: { required, validatorRus },
      first_name: { required, validatorRus },
      patronymic: { validatorRus },
      date_of_birth: { required },
      address: { required, validatorRusDigit },
      // type_document: null,
      series_document: { validatorSeries },
      number_document: { validatorNumber }

    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    payer () {
      return this.$store.getters['gis_gmpPayer/payer']
    },
    formTitle () {
      return this.$route.params.payer_id === 'new' ? 'Добавить карточку' : 'Карточка'
    },
    typeDocument () {
      return this.$store.getters['gis_gmpPayer/typeDocument']
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize () {
      let id = this.$route.params.payer_id
      if (id === 'new') {
        this.$store.commit('gis_gmpPayer/setDefaultPayer')
      } else {
        this.$store.dispatch('gis_gmpPayer/fetchPayer', {
          id: id })
      }
      this.$store.dispatch('gis_gmpPayer/fetchTypeDocument')
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('gis_gmpPayer/insertPayer', this.payer)
          .then(() => {
            if (this.$route.params.payer_id === 'new') {
              this.$router.push({
                name: 'gis_gmp_charges',
                params: {
                  'payer_id': this.payer.id
                }
              })
            }
          }
          )
      }
    },
    del () {
      if (this.payer.id !== 'new') {
        this.$store.dispatch('gis_gmpPayer/deletePayer', this.payer.id)
          .then(() => {
            this.$router.push({ name: 'gis_gmp_list_payer' })
          })
      }
    },
    cancel () {
      this.$router.push({ name: 'gis_gmp_list_payer' })
    },
    requiredErrors (fieldName) {
      const errors = []
      const field = this.$v.payer[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      if (field.hasOwnProperty('email')) {
        !field.email && errors.push('Это не адрес электронной почты')
      }
      if (field.hasOwnProperty('validatorRus')) {
        !field.validatorRus && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorRusDigit')) {
        !field.validatorRusDigit && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorPhone')) {
        !field.validatorPhone && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorSeries')) {
        !field.validatorSeries && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorNumber')) {
        !field.validatorNumber && errors.push('Некорректные символы')
      }
      return errors
    },
    getTypeDocument (id) {
      return this.$store.getters['gis_gmpPayer/getTypeDocument'](id)
    },
    setNullDocument () {
      this.payer.series_document = ''
      this.payer.number_document = ''
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .bloc_inline
  {
    display:inline-block;
  }
    .bloc
    {
        border: 1px solid gray
    }
</style>
